import Paths from 'config/paths';
import { basicUrlPagination } from 'utils/functions';
import { defaultQueries } from 'utils/helpers/helper';

// Paths de "Lotes Bienes" y "Lotes Propiedades".
// Para clientes (CLI) van al bloque "Menú" en vez de la categoría Administración.
export const LOT_PATHS = [
  `${Paths.LOTS}?areaId=1${basicUrlPagination}`,
  `${Paths.LOTS}?areaId=2${basicUrlPagination}`,
];

// Agrupación de las entradas de administración por categoría (colapsables).
// Cada categoría lista los paths (keys de `Menus`) que la componen, en orden.
// Los paths que no figuren aquí se renderizan sueltos bajo "Menú".
export const ADMIN_CATEGORIES = [
  {
    label: 'Administración',
    paths: [
      Paths.SAP,
      Paths.USERS,
      LOT_PATHS[0],
      LOT_PATHS[1],
      Paths.SORT_LOTS,
      Paths.ENTITLED_LOTS,
      Paths.GUARANTEES_AND_PAYMENTS,
    ],
  },
  {
    label: 'Remates',
    paths: [
      Paths.AUCTIONS + defaultQueries.fortinures.all,
      Paths.AUCTIONS + defaultQueries.properties.all,
      `${Paths.FINISHED_AUCTIONS.replace(':areaID', '1')}?&page=1&limit=10`,
      Paths.VIEW_REPORT,
      Paths.HIDDEN_LOTS,
    ],
  },
  {
    label: 'Venta Directa',
    paths: [Paths.FEATURED_LOTS_MANAGER, Paths.CONTACTS_MANAGER],
  },
  {
    label: 'Mantenedores',
    paths: [
      Paths.BRANDS_MANAGER,
      Paths.MODELS_MANAGER,
      Paths.VEHICLE_TYPES_MANAGER,
      Paths.SELLER_MANAGER,
      Paths.CURRENCY_MANAGER,
      Paths.AUCTION_CATEGORIES,
      Paths.LOT_CATEGORIES,
      Paths.CATEGORIES_V2,
    ],
  },
  {
    label: 'Otros',
    paths: [Paths.SYSTEM_CHANGES, Paths.CONTACT_MESSAGES],
  },
];

// Para clientes: Administración sin los Lotes (van al Menú) y Remates primero.
export const buildClientCategories = () => {
  const withoutLots = ADMIN_CATEGORIES.map((cat) => ({
    ...cat,
    paths: cat.paths.filter((p) => !LOT_PATHS.includes(p)),
  }));
  return [
    ...withoutLots.filter((cat) => cat.label === 'Remates'),
    ...withoutLots.filter((cat) => cat.label !== 'Remates'),
  ];
};
